import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../environments/environment';
import { LoginBody } from '../models/user-master/commands/login-body';

import { ApiResponse } from '@card-software/nexus-utilities';

@Injectable({
  providedIn: 'root',
})
export class UserMasterProxyService {
  private readonly baseUrl = environment.proxyUrls.userMasterApi + '/api/v1/authentication';
  private readonly httpClient = inject(HttpClient);

  login(loginBody: LoginBody): Observable<ApiResponse<string>> {
    return this.httpClient.post<ApiResponse<string>>(`${this.baseUrl}/login`, loginBody);
  }
}
